import { render } from "./Addition.vue?vue&type=template&id=9cc8e50e"
import script from "./Addition.vue?vue&type=script&lang=js"
export * from "./Addition.vue?vue&type=script&lang=js"

import exportComponent from "/home/hosting_users/shoplus/custom/survey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__